module.exports = __webpack_public_path__ + "img/32_5.0271a274.png";